import React, {useCallback, useEffect, useState} from 'react';

import Reply from "./Components/Reply";
import TextArea from "./Components/TextArea";
import RightClickMenu from "./Components/RightClickMenu";


const style = {
    outline: "2px solid orange",

}


const MainNode = ({data,id, type}) => {
    // const onChange = useCallback((evt) => {
    //
    // }, []);
    const [replyNum, setReplyNum] = useState([])
    const [stl, setStl] = useState({})

    const [active, setActive] = useState(false)
    const [menu, showMenu] = useState(false)

    const onDoubleClick = useCallback((event)=>{
        setActive(true)
        setStl(style)
    },[active])

    const DisableActive = useCallback((event)=>{
        if(!data.start){
            setStl({})
        }else
        setStl({outline: "2px solid white",})
        setActive(false)
        showMenu(false)
       // document.getElementById( 'TextArea' ).scrollTop = 0

    },[active])

    useEffect(()=>{
        data.ActivFun = DisableActive
        data.active = onDoubleClick

        setReplyNum(data.replys)

        if(data.start)
            setStl({outline: "2px solid white",})

    },[])





    const createReply =useCallback(()=>{
        setReplyNum(data.replys)
        let arr = replyNum
        arr.push({text:""})
        setReplyNum(arr)
        data.ReplyNum = arr.length
        //
       // data.replys.push({text:""})
        // data.replys = [...data.replys, {text:""}]
    },[replyNum])

    const removeReply =()=>{
        let arr = replyNum
        arr.pop()
        setReplyNum(arr)
        data.ReplyNum = arr.length
        data.onReplyRemove(id, arr.length)

        // const qq = data.replys.pop()
        // data.replys = [qq]
    }

    return (
        <div
            style={stl}
            className="text-updater-node">

            <TextArea data ={data} isFocused={active} type={type}/>
            {replyNum.map((value, index)=>(<Reply key={index} data={data} id={index} id1={`${index}`} id2={`${index}`}/>))}

            { !active &&   <div
                onContextMenu={
                    event => {
                        event.preventDefault()
                        showMenu(!menu)
                    }
                }

                className="Shild"></div>  }

            {menu && <RightClickMenu data={data} id={id} showSetStart={true}/>  }

            { active &&    <button onClick={createReply} className="PlusButton">+</button>}
            { active &&    <button onClick={removeReply} className="PlusButton2">-</button>}
        </div>
    );
};

export default MainNode